<template>
	<section 	id="fullscreenImage"
				data-icon="camera"
				data-title="Background Image"
				class="w-100 bg-cover py-0">
		<div class="bg-cover" :class="image_class">
			<div id="content" class="position-absolute w-100 h-100 text-white d-flex flex-wrap align-content-center text-center justify-content-center p-2 p-lg-3 px-lg-5">
				<b-row class=" d-flex align-items-center px-lg-5">
					<b-col cols="12" class="px-lg-5">
						<h2 class="m-0 large px-lg-5">
							<span v-if="$creo.getLang() == 'sv'">JM ska vara kundens förstahandsval vid köp av ny bostad. </span>
							<span v-else>JM should be the customer’s first choice when buying a new home.</span>
						</h2>
					</b-col>
				</b-row>
			</div>
		</div>
	</section>
</template>
<script>
	export default {
		name: 'FullscreenImage',
		props: {
			image_class: {
				type: String,
				default: null
			}
		},
		data() {
			return {
				bgMove: false,
				container: null,
				width: null,
				height: null
			}
		},
	}
</script>
